import { updateKeyInStore } from 'App';
import * as Yup from 'yup';
import { store } from 'app/redux/store';

import { HomeOfficeStateValues, updateKey, updateFieldArrayKey } from './slice';

export const fields: IBaseField<keyof HomeOfficeStateValues | any>[] = [
  {
    name: 'didYouMaintainAHomeOfficeThisYear',
    label: 'Did you maintain a home office this year?',
    type: 'radio',
    effect: updateKeyInStore(updateKey),
    tooltip: '',
    comment: true,
    dependencies: [
      {
        name: 'totalNumberOfSquareFeetOfYourHome',
        label: 'Total number of square feet of your home',
        type: 'number',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v == 'yes',
        comment: true,
      },
      {
        name: 'totalNumberOfSquareFeetOfTheAreaUsedForYourHomeOffice',
        label:
          'Total number of square feet of the area used for your home office',
        type: 'number',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v == 'yes',
        comment: true,
      },
      {
        dependenciesTitle:
          'For what period of time did you use your home office during the year?',
        name: 'usedHomeOfficeFrom',
        label: 'From',
        type: 'date',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v == 'yes',
        comment: true,
      },
      {
        name: 'usedHomeOfficeFromTo',
        label: 'To',
        type: 'date',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v == 'yes',
        comment: true,
      },
      {
        name: 'isThereAnyCostsForYourHomeForThatTimePeriod',
        label: 'Is there any costs for your home for that time period?',
        type: 'radio',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v == 'yes',
        comment: true,
        dependencies: [
          {
            name: 'rent',
            label: 'Rent',
            type: 'number',
            effect: updateKeyInStore(updateKey),
            predicate: (v) => v == 'yes',
            comment: true,
          },
        ],
      },

      {
        name: 'insurance',
        label: 'Insurance',
        type: 'number',
        effect: updateKeyInStore(updateKey),
        tooltip: '',
        comment: true,
      },
      {
        name: 'utility',
        label: 'Utility',
        type: 'number',
        effect: updateKeyInStore(updateKey),
        tooltip: '',
        predicate: (v) => v == 'yes',
        comment: true,
      },

      {
        name: 'expenses',
        label: 'Expenses',
        type: 'fieldArray',
        predicate: (v) => v == 'yes',
        dependencies: [
          {
            name: 'name',
            label: 'Name',
            type: 'text',
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            comment: true,
          },
          {
            name: 'amount',
            label: 'Amount',
            type: 'number',
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            comment: true,
          },
        ],

        effect: (payload) => store.dispatch(updateFieldArrayKey(payload)),
        tooltip: '',
        comment: true,
      },
    ],
  },
];

export const validationSchema = Yup.object().shape({});
